export default {
  numbersBlacklist: []
}
